import AuthPage from "components/shared/AuthPage";
import { Link } from "react-router-dom";

function Main() {
    return (
        <AuthPage userAuthenticated={false}>
            <div className="main">
                Hello world! Main page here
                <Link to="/">Link to App</Link>
            </div>
        </AuthPage>
    );
}

export default Main;
